import { BlueprintData } from '@rta/rta-blueprint-library';

/**
 * Removes null entries from blueprint kitchen/panel arrays so the library can
 * reconstruct objects without crashing on null values.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sanitizeBlueprintData = (data: BlueprintData): BlueprintData => {
	if (!data || typeof data !== 'object') {
		return data;
	}

	const sanitized = JSON.parse(JSON.stringify(data));

	if (sanitized.kitchens && Array.isArray(sanitized.kitchens)) {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		sanitized.kitchens = sanitized.kitchens.map((kitchen: any) => {
			if (!kitchen || typeof kitchen !== 'object') return kitchen;

			if (kitchen.panels && typeof kitchen.panels === 'object') {
				if (kitchen.panels.panelItemGroups && Array.isArray(kitchen.panels.panelItemGroups)) {
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					kitchen.panels.panelItemGroups = kitchen.panels.panelItemGroups.map((group: any) => {
						if (!group || typeof group !== 'object') return group;

						if (group.panelItems && Array.isArray(group.panelItems)) {
							// eslint-disable-next-line @typescript-eslint/no-explicit-any
							group.panelItems = group.panelItems.filter((item: any) => item !== null && typeof item === 'object');
						}

						return group;
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					}).filter((group: any) => group !== null && typeof group === 'object');
				}

				if (kitchen.panels.panelItems && Array.isArray(kitchen.panels.panelItems)) {
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					kitchen.panels.panelItems = kitchen.panels.panelItems.filter((item: any) => item !== null && typeof item === 'object');
				}
			}

			return kitchen;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		}).filter((kitchen: any) => kitchen !== null && typeof kitchen === 'object');
	}

	return sanitized;
};
